'use strict';

import BidHistory from './components/BidHistory.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('bid-history', BidHistory);

    }
}